import React from 'react'
import PropTypes from 'prop-types'
import CardGrid from '../../components/card-grid/card-grid'
import Layout from '../../components/layout'
import StructuredData from "../../components/structured-data";
import SeoTags from '../../components/seo-tags'

import * as utils from '../../utils'

const TITLE = "Autokwix - off-road trucks Mods & Performance Parts ratings";
const DESCRIPTION = "Autokwix.com - off-road trucks and SUVs Accessories & Performance Parts ratings. Jeep Wrangler, Dodge, Ford F150, Chevy Silverado Mods reviews and News!";

export default class ArticlesPage extends React.Component {
  render() {
    const { data } = this.props
    const { edges: reviews } = data.reviewsDataAll
    const { edges: blogs } = data.blogsData

    const cards = [...blogs, ...reviews].map((item) => ({
      id: item.node.id,
      slug: item.node.fields.slug,
      title: utils.updateYearToCurrent(item.node.frontmatter.title),
      excerpt: item.node.frontmatter.introduction || item.node.excerpt,
      created: item.node.frontmatter.created,
      author: item.node.frontmatter.seo.author,
      image: item.node.frontmatter.image,
    }));

    return (
      <Layout>
        <StructuredData isReview={false} />
        <SeoTags
          title={TITLE}
          description={DESCRIPTION}
        />
        <div>
          <CardGrid data={cards}/>
        </div>
      
      </Layout>
    )
  }
}

ArticlesPage.propTypes = {
  data: PropTypes.shape({
    reviewsDat2: PropTypes.shape({
      edges: PropTypes.array,
    }),
    blogsData: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query ArticlesQuery {
    reviewsDataAll: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___created] }
      filter: { frontmatter: { templateKey: { eq: "review-page" } } }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            slug
            title
            introduction
            image
            seo {
              author
            }
            created(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
    blogsData: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___created] }
      filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
    ) {
      edges {
        node {
          id
          excerpt
          fields {
            slug
          }
          frontmatter {
            slug
            title
            image
            seo {
              author
            }
            created(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/articles/index.js